import styled from "styled-components";

export const PropertyStatusBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 40px;
  width: auto;
  min-width: 97px;
  padding: 1.5px 10px;
  cursor: default;
  background-color: ${({ $backgroundColor }) => $backgroundColor || "transparent"};
  color: ${({ $textColor }) => $textColor || "#000"};
  font-size: ${({ $fontSize }) => $fontSize || "11px"};
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  
  /* Border radius: 
     - Si hay múltiples badges unidos: solo las esquinas exteriores tienen border-radius
     - Si hay un solo badge: todas las esquinas tienen border-radius (4px)
  */
  ${({ $hasMultipleBadges, $isFirst, $isLast }) => {
    if (!$hasMultipleBadges) {
      // Un solo badge: todas las esquinas tienen border-radius
      return "border-radius: 4px;";
    } else {
      // Múltiples badges: solo las esquinas exteriores
      return `
        border-top-left-radius: ${$isFirst ? "4px" : "0"};
        border-bottom-left-radius: ${$isFirst ? "4px" : "0"};
        border-top-right-radius: ${$isLast ? "4px" : "0"};
        border-bottom-right-radius: ${$isLast ? "4px" : "0"};
      `;
    }
  }}
`;

